// src/modules/app-views/invoices/pages/Init/modals/PrinterConfigModal/index.jsx
import { useMemo } from 'react';
import { PrinterOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import printerConfigStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const PrinterConfigModal = ({ show, setShow, afterClose, onSuccess }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const steps = useMemo(() => [printerConfigStep()], []);

  // ─────────────────────────────────────────────────────────────────────────────
  // HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleFinish = async () => {
    onSuccess?.();
    return true;
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<PrinterOutlined />}
      title="printer_configuration"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={520}
      maskClosable={false}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default PrinterConfigModal;
